module.exports = __webpack_public_path__ + "static/media/login-welcome-log.4bf3846c.png";